import React from "react";
import styled from "styled-components";
import { Button, Stack } from "@mui/material";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import { ToastContext } from "src/components/providers/toast-provider";
import { Login } from "@mui/icons-material";
import { useTeams } from "../teams-provider";
import { useTeam } from "./team-provider";
import useTeamAction from "../hooks/use-team-action";

const TeamJoinButton = styled(Button)`
    font-size: 12px;
    font-weight: 300;
    text-transform: none;
    padding: 0;
    color: ${({ theme }) => theme.palette.primary.main};

    &:hover {
        background-color: ${({ theme }) => theme.palette.background.default};
    }
`;

const TeamJoin = ({ team }) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const teamsApi = useTeams();
    const teamApi = useTeam();
    const { user } = useAuth();

    if (!team || !team.members || !!team.members.find((member) => member.id === user.id))
        return null;

    const joinAction = useTeamAction(
        async () => {
            await request(`/api/teams/${team.id}/join`, { method: "PUT" });
            setMessage(`Joined ${team.name} Successfully`);
            setSeverity("success");
            setIsToastTriggered(true);
            teamApi.refetch();
            teamsApi.refetch();
        },
        () => {
            setMessage(`You can not perform this action on demo mode`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    );

    const handleSubmitJoin = async (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsToastTriggered(false);
        try {
            joinAction();
        } catch (error) {
            setMessage(`Error try again`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };
    return (
        <Stack>
            <TeamJoinButton startIcon={<Login />} onClick={handleSubmitJoin}>
                Join Team
            </TeamJoinButton>
        </Stack>
    );
};

export default TeamJoin;
